var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "url(#paint0_radial_50_79)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_79)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_50_79)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_50_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15L20 21M33 15L28 21M27.5 14L25 20M20.5 14L23 20",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 34C25.8565 34 27.637 33.2625 28.9497 31.9497C30.2625 30.637 31 28.8565 31 27C31 25.1435 30.2625 23.363 28.9497 22.0503C27.637 20.7375 25.8565 20 24 20C22.1435 20 20.363 20.7375 19.0503 22.0503C17.7375 23.363 17 25.1435 17 27C17 28.8565 17.7375 30.637 19.0503 31.9497C20.363 33.2625 22.1435 34 24 34Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 30.5C24.9283 30.5 25.8185 30.1313 26.4749 29.4749C27.1313 28.8185 27.5 27.9283 27.5 27C27.5 26.0717 27.1313 25.1815 26.4749 24.5251C25.8185 23.8687 24.9283 23.5 24 23.5C23.0717 23.5 22.1815 23.8687 21.5251 24.5251C20.8687 25.1815 20.5 26.0717 20.5 27C20.5 27.9283 20.8687 28.8185 21.5251 29.4749C22.1815 30.1313 23.0717 30.5 24 30.5Z",
    stroke: "white",
    strokeWidth: 1.5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_50_79",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0614 1.7561) rotate(90.0761) scale(46.2439 46.2439)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357CD2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_50_79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_50_79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFIcon4);
export default __webpack_public_path__ + "static/media/f_icon4.5abf0a8ac160bbbe4a915cf084d71801.svg";
export { ForwardRef as ReactComponent };